module.exports = __webpack_public_path__ + "img/aoc-big2.8a0496e7.png";